import React from "react"
import { graphql } from "gatsby"
import { Typography, withStyles } from "@material-ui/core"
import Link from "@material-ui/core/Link"
import { Layout } from "../components/layout"
import { MyMarkdown } from "../components/MyMarkdown"

export const pageQuery = graphql`
    query($slug: String!) {
        googleSheetExhibitorsRow(fields: {slug: {eq: $slug}}) {
            name,
            text,
            webpage,
            childrenDropboxNode {
                localFile {
                    childImageSharp {
                        fluid(maxWidth: 300, maxHeight: 64, fit: CONTAIN, background: "rgba(255, 255, 255, 0)", toFormat: PNG) {
                            src
                        }
                    }
                }
            }
        }
    }
`

const styles = (theme) => ({
    spaceTop: {
        marginTop: theme.spacing(4),
    },
    rightLeft: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        flexWrap: 'wrap',
    },
    avatar: {
        height: theme.spacing(16),
        width: theme.spacing(16),
    },
    text: {
        marginTop: theme.spacing(4),
    },
})

const getSrcSet = (node) => {
    const cdn = node.childrenDropboxNode[0]
    if (!cdn) return null
    console.log(cdn.localFile.childImageSharp.fluid);
    return cdn.localFile.childImageSharp.fluid.src
}

const exhibitorTemplate = ({ data, classes }) => {
    const exhibitor = data.googleSheetExhibitorsRow

    return (
        <Layout title={exhibitor.name}>

            <div className={classes.rightLeft}>
                <Typography variant='h2'>{exhibitor.name}</Typography>
                {/*<Img fluid={getSrcSet(exhibitor)}/>*/}
                <img alt={'Aussteller Logo'} src={getSrcSet(exhibitor)} />
                {/*<Avatar className={classes.avatar} src={getSrcSet(exhibitor)}/>*/}
            </div>

            <div className={classes.text}>
                <MyMarkdown children={exhibitor.text}/>
            </div>

            {exhibitor.webpage && <Link href={exhibitor.webpage}>{exhibitor.webpage}</Link>}
        </Layout>
    )
}

export default withStyles(styles)(exhibitorTemplate)